import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/page-header";
import { Button, Container, Table } from "react-bootstrap";
import LoadingIndicator from "../../components/loading-indicator";
import { useTranslation } from "react-i18next";
import { Puzzle } from "../../models/Puzzle";
import { Era } from "../../models/era";
import { getPuzzle } from "../../services/api";

export default function PuzzleDetailsPage() {
    const { id } = useParams<string>();
    const { t, i18n } = useTranslation();

    const [level, setLevel] = useState<Puzzle | null>(null);
    const [eras, setEra] = useState<Era[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        getPuzzle(id).then((res) => {
            if (res) {
                setLevel(res);
            }
        })
    }, [])

    return level ? (
        <>
            <PageHeader title={t("level_title")} />
            <Container fluid>
                <>
                    {level ? (
                        <Table bordered striped>
                            <tbody>
                                <tr>
                                    <td className="w-100 field-label" colSpan={2}>
                                        {t("level_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-50 text-start">
                                        {level.level}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100 field-label" colSpan={2}>
                                        {t("text_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100" colSpan={2}>
                                        {level.text}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100 field-label" colSpan={2}>
                                        {t("raw_text_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100" colSpan={2}>
                                        {level.rawText}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100 field-label" colSpan={2}>
                                        {t("author_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100" colSpan={2}>
                                        {level.author}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100 field-label" colSpan={2}>
                                        {t("country_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100" colSpan={2}>
                                        {level.country}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100 field-label" colSpan={2}>
                                        {t("era_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="w-100" colSpan={2}>
                                        {level.era}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="field-label">
                                        {t("time_created_column_header")}
                                    </td>
                                    <td className="field-label">
                                        {t("time_modified_column_header")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {
                                            level.timeCreated
                                                ? level.timeCreated.toISOString()
                                                : "\u00A0"
                                        }
                                    </td>
                                    <td>
                                        {
                                            level.timeModified
                                                ? level.timeModified.toISOString()
                                                : "\u00A0"
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    ) : (
                        <LoadingIndicator />
                    )}
                    <div className="mt-3 float-end">
                        <Button
                            type="button"
                            variant="secondary"
                            className="px-4 py-2"
                            onClick={() => { navigate("/admin/puzzles") }}
                        >
                            {t("back_button_label")}
                        </Button>
                    </div>
                </>
            </Container>

        </>
    ) : (
        <div>Loading...</div>
    );
};